__turbopack_context__.v({
  "className": "work_sans_eef4810e-module__koMtPq__className",
  "variable": "work_sans_eef4810e-module__koMtPq__variable",
});
